<template>
  <!-- eslint-disable -->
  <div>
    <b-row class="mb-2">
      <b-col sm="12">
        <b-button variant="danger" @click.prevent="back">Atras</b-button>
      </b-col>
    </b-row>
    <b-row v-if="datosMov">
      <b-col sm="12">
        <b-card no-body header-bg-variant="dark">
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información de Movimiento</h4>
          </b-card-header>
          <b-card-body class="mt-2">
            <b-row>
              <b-col sm="4" lg="4" class="flex">
                <strong>Tienda: </strong>
                <p class="">{{ datosMov.storeSelected.name }}</p>
              </b-col>
              <b-col sm="4" lg="4" class="flex">
                <strong>Tipo de documento: </strong>
                <p class="">{{ datosMov.document_type }}</p>
              </b-col>
              <b-col sm="4" lg="4" class="flex">
                <strong>Descripción: </strong>
                <p class="">{{ datosMov.documentDescription }}</p>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Detalles de Movimiento</h4>
          </b-card-header>
          <b-card-text class="">
            <b-table
              class="position-relative"
              :hover="true"
              :items="details"
              responsive
              :fields="fields"
              show-empty
              empty-text="No existen"
              @sort-changed="sortChanged"
            >
            </b-table>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                    <b-form-select
                      v-model="showEntrie"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="entries"
                      @change="changeSizePage"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="3" class="mt-75" style="font-size: 12px">
                  <span> {{ totalElements }} Registros en total</span>
                </b-col>
                <!-- Pagination -->
                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalElements"
                    :per-page="showEntrie"
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @change="cambioPagina"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ExternalMovement from '@/services/ExternalMovement'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      datosMov: null,
      details: [],
      fields: [
        { key: 'autopart.uniqueCode', label: 'Código Único', sortable: true },
        { key: 'autopart.originalCode', label: 'Codigo Original', sortable: true },
        { key: 'autopart.alterCode', label: 'Codigo Alter.', sortable: true },
        { key: 'autopart.description', label: 'Descripción', sortable: false },
        { key: 'qty', label: 'Cantidad', sortable: true },
        { key: 'price', label: 'Precio' }
      ],
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc'
    
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    back() {
      this.$store.commit('back/setIndexTabME', 1)
      this.$router.push('/inventario/salida')
    },
    async getData() {
      this.details = []
      this.totalElements = 0
      const getMov = await ExternalMovement.getMovExternal(this.$route.params.id, this.$store)
      if (getMov) {
        this.datosMov = getMov.movement
        this.details = getMov.detail
        this.totalElements = getMov.detail.length
      }
      console.log('this.datosMov', this.datosMov)
      console.log(' this.details', this.details)
    }
  }
}
</script>

<style></style>
